import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog } from "primereact/dialog";
import Langs, { Localize } from "../../../app/lang/langs";
import { InputField } from "../../inputs/InputField";
import { DynamicButton } from "../../buttons/DynamicButton";
import { Row } from "primereact/row";
import { Col } from "react-bootstrap";
import moment from "moment";
import { addNews, getDashboardData, markNewsAsRead } from "../../../containers/dashboard/dashboardSlice";
import { showSuccessToast } from "../../../app/utils/helpers";


export default function AddNewsModal(props) {

    const dispatch = useDispatch()
    const isMobile = useSelector((state) => state.settings.isMobile)
    const [updatedItem, setUpdatedItem] = useState({ title: '', message: '' })

    const userId = useSelector((state) => state.login.userId)
    const lastNewsId = useSelector((state) => state.dashboard.lastNewsId)

    const handleFieldChange = (value, field) => {
        setUpdatedItem(prev => ({
            ...prev,
            [field.key]: value
        }))
    }


    const handleMarkAsRead = async () => {
        try {
            await dispatch(markNewsAsRead({
                newsId: props.selectedNews.id,
                userId: userId
            })).unwrap();

            dispatch(getDashboardData({ lastNewsId: lastNewsId }));
        } catch (err) {
            console.error("Error updating news:", err);
        }
    };

    const visibleFields = [
        { key: "title", type: "string", disabled: false },
        { key: "message", type: "text", disabled: false, rows: 6 },
        // { key: "created_by", type: "string", disabled: false },
        // { key: "created_at", type: "date", disabled: false },
    ]

    function getFormatDate(dateKey) {
        if (updatedItem[dateKey]) {
            return moment(updatedItem["dateKey"]).format("YYYY-MM-DD 00:00:00")
        }
        return null
    }

    const handleSave = async () => {
        try {
            const response = await dispatch(
                addNews({ title: updatedItem.title, message: updatedItem.message })
            ).unwrap();
            if (response.responseData && response.responseData.status) {
                showSuccessToast(Localize("NEWS_ADDED_SUCCESSFULLY"))
                handleClose();
                dispatch(getDashboardData({ lastNewsId }));
            }
        } catch (error) {
            console.error("Error saving news:", error);
        }
    };


    const footer = () => {
        if (updatedItem["title"].trim() != '' && updatedItem["message"].trim() != '') {
            return <Row className="d-flex justify-content-center" >
                <Col lg={2} xs={2}>
                    <DynamicButton
                        onClick={handleSave}
                        className='me-auto'
                        title={<Langs str="SEND" />}
                        active={true}
                        color="green"
                    />
                </Col>
            </Row>
        }
    }

    const handleClose = () => {
        setUpdatedItem({ title: '', message: '' })
        props.setVisible(false)
    }

    return (
        <Dialog
            visible={props.visible}
            style={{ width: isMobile === 2 ? "90%" : "50%" }}
            onHide={() => {
                handleClose()
            }}
            header={<Langs str="ADD_NEWS" />}
            draggable={false}
            dismissableMask={false}
            footer={footer}
        >
            {visibleFields.map(field => <InputField field={field}
                onChange={(e) => handleFieldChange(e, field)}
                value={updatedItem && updatedItem[field.key]} />
            )}
        </Dialog>
    )
}